import React from "react";
import { Modal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import { Button } from "@/components";
import { useModalNavigation } from "../../hooks/useModalNavigation";
import styles from "./RegistrationSuccessModal.module.scss";

interface RegistrationSuccessModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

export const RegistrationSuccessModal: React.FC<RegistrationSuccessModalProps> = ({
  isOpen,
  setIsOpen,
  onClose,
}) => {
  const { handleEndProcess } = useModalNavigation();

  return (
    <Modal
      title={ModalTexts.register.regSuccess.TITLE}
      subTitle={ModalTexts.register.regSuccess.SUB_TITLE}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={onClose}
    >
      <Button newStyles={styles.button} onClickFunc={handleEndProcess}>
        Ок
      </Button>
    </Modal>
  );
};

